define('score_bootstrap/Components/ContentSearch/FacetContainer',[
   "jquery",
   "knockout",
   "underscore",
   "eventManager",   
   "score_bootstrap/Utils/UrlHelper",
   "score_bootstrap/Events/SearchRequestChangeEvent",
   "score_bootstrap/Events/SearchResponseEvent",
   "score_bootstrap/Models/Search/FacetPanel",
   "score_bootstrap/Models/Search/FacetRangePanel",
   "score_bootstrap/Models/Search/FacetRatingsPanel",
   "score_bootstrap/Models/SitecoreId"
], function (
   $,
   ko,
   _,
   eventManager,   
   urlHelper,
   SearchRequestChangeEvent,
   SearchResponseEvent,
   FacetPanel,
   FacetRangePanel,
   FacetRatingsPanel,
   SitecoreId
) {
    "use strict";

    function FacetContainer(scope, uniqueId, inputChangeEvents) {
        var self = this,
            urlParam = uniqueId + "facet",
            facetRangeUrlParam = urlParam + "Range",
            facetRatingsUrlParam = urlParam + "Ratings",
            preselected,
            rangePreselected,
            ratingsPreselected,
            hasPreselected,
            clearAllInProgress = false,
            facetValues;

        getPreselectedValues();

        this.facetPanels = $(".score-facet-panel", scope).toArray().map(function (el) {
            return new FacetPanel(el, preselected);
        });

        this.facetRangePanels = $(".score-facet-range-panel", scope).toArray().map(function (el) {
            return new FacetRangePanel(el, rangePreselected);
        });

        this.facetRatingsPanels = $(".score-facet-ratings-panel", scope).toArray().map(function (el) {
            return new FacetRatingsPanel(el, ratingsPreselected);
        });

        window.addEventListener('hashchange', (function () {

            getPreselectedValues();

            this.facetPanels.forEach(function (panel) {
                panel.selectValues(preselected);
            });

            this.facetRangePanels.forEach(function (panel) {
                panel.selectValues(rangePreselected);
            });

            this.facetRatingsPanels.forEach(function (panel) {
                panel.selectValues(ratingsPreselected);
            });

        }).bind(this));

        facetValues = Array.prototype.concat.apply([], _.pluck(this.facetPanels, "facets"));

        function getPreselectedValues() {
            preselected = urlHelper.getHashValue(urlParam);
            rangePreselected = urlHelper.getHashValue(facetRangeUrlParam);
            ratingsPreselected = urlHelper.getHashValue(facetRatingsUrlParam);

            preselected = preselected ? preselected.split(",") : [];
            hasPreselected = preselected.length > 0;
            preselected = preselected.reduce(processPreselected, {});

            rangePreselected = rangePreselected ? rangePreselected.split("|") : [];
            hasPreselected = hasPreselected || rangePreselected.length > 0;
            rangePreselected = rangePreselected.reduce(processPreselected, {});

            ratingsPreselected = ratingsPreselected ? ratingsPreselected.split(",") : [];
            hasPreselected = hasPreselected || ratingsPreselected.length > 0;
            ratingsPreselected = ratingsPreselected.reduce(processPreselected, {});
        }

        function triggerFacetChange(selectedFacets, selectedFacetRanges, selectedFacetRatings) {
            var data;
            
            if (selectedFacets.length || selectedFacetRanges.length || selectedFacetRatings.length) {
                urlHelper.setHashValue(window.location, urlParam, selectedFacets.length ? selectedFacets.join(",") : null);
                urlHelper.setHashValue(window.location, facetRangeUrlParam, selectedFacetRanges.length ? selectedFacetRanges.join("|") : null);
                urlHelper.setHashValue(window.location, facetRatingsUrlParam, selectedFacetRatings.length ? selectedFacetRatings.join(",") : null);
            } else {
                urlHelper.removeHash();
            }
          
            if (inputChangeEvents.length) {
                data = new SearchRequestChangeEvent({
                    page: 0,
                    startPage: 0,
                    facets: self.facetPanels.map(function (facetPanel) {
                        return {
                            title: facetPanel.title,
                            logic: facetPanel.searchLogicType,
                            values: facetPanel.facets.map(function (facet) {
                                return {
                                    id: facet.id.toString(),
                                    value: facet.value,
                                    text: facet.text,
                                    selected: facet.selected()
                                };
                            })
                        };
                    }),
                    rangeFacets: self.facetRangePanels.filter(function (f) { return f.rangeFacet; }).map(function (facetPanel) {
                        var selectedValueArray = facetPanel.rangeFacet.split(",");

                        return {
                            id: facetPanel.id,
                            title: facetPanel.title,
                            logic: facetPanel.searchLogicType,
                            indexFieldName: facetPanel.indexFieldName,
                            minValue: selectedValueArray[0], 
                            maxValue: selectedValueArray[1]
                        }
                    }),
                    ratingsFacets: self.facetRatingsPanels.filter(function (f) { return f.rating; }).map(function (facetPanel) {
                        return {
                            id: facetPanel.id,
                            title: facetPanel.title,
                            logic: facetPanel.searchLogicType,
                            indexFieldName: facetPanel.indexFieldName,
                            ratingValue: facetPanel.rating ? facetPanel.rating : 0
                        }
                    })
                });

                inputChangeEvents.forEach(function (ev) {
                    eventManager.trigger(SearchRequestChangeEvent.eventName + ":" + ev, data);
                });

                // Enable/disable Clear Facets button
                var hasActiveFacets = selectedFacets.length || selectedFacetRanges.length || selectedFacetRatings.length;
                $('.clear-facets', scope)
                    .toggleClass('disabled', !hasActiveFacets)
                    .attr('aria-disabled', !hasActiveFacets);
            }
        }

        function clearAll() {
            clearAllInProgress = true;
            self.facetPanels.forEach(function (panel) {
                panel.unselectAll();
            });
            self.facetRangePanels.forEach(function (panel) {
                panel.unselectAll();
            });
            self.facetRatingsPanels.forEach(function (panel) {
                panel.unselectAll();
            });

            triggerFacetChange([], [], []);
            clearAllInProgress = false;
        }

        this.selectedFacets = ko.pureComputed(function () {
            return this.facetPanels.reduce(function (result, facetPanel) {
                var asStr = facetPanel.asString;
                if (asStr !== null) {
                    result.push(asStr);
                }

                return result;
            }, []);
        }, this);

        this.selectedFacetRanges = ko.pureComputed(function () {
            return this.facetRangePanels.reduce(function (result, facetPanel) {
                var asStr = facetPanel.asString;
                if (asStr !== null) {
                    result.push(asStr);
                }

                return result;
            }, []);
        }, this);

        this.selectedFacetRatings = ko.pureComputed(function () {
            return this.facetRatingsPanels.reduce(function (result, facetPanel) {
                var asStr = facetPanel.asString;
                if (asStr !== null) {
                    result.push(asStr);
                }

                return result;
            }, []);
        }, this);

        if (hasPreselected) {
            triggerFacetChange(self.selectedFacets(), self.selectedFacetRanges(), self.selectedFacetRatings());
        }

        this.selectedFacets.subscribe(function (facets) {
            if (clearAllInProgress === false) {
                triggerFacetChange(facets, self.selectedFacetRanges(), self.selectedFacetRatings());
            }
        });

        this.selectedFacetRanges.subscribe(function (facets) {
            if (clearAllInProgress === false) {
                triggerFacetChange(self.selectedFacets(), facets, self.selectedFacetRatings());
            }
        });

        this.selectedFacetRatings.subscribe(function (facets) {
            if (clearAllInProgress === false) {
                triggerFacetChange(self.selectedFacets(), self.selectedFacetRanges(), facets);
            }
        });

        this.clearAll = clearAll;

        $(scope).on("click", ".panel-heading", function () {
            var $this = $(this);
            if ($this.hasClass("static")) {
                return;
            }

            $this.next().slideToggle();
            $this.toggleClass("opened").toggleClass("closed");
            $this.attr("aria-expanded", $this.hasClass("opened"));
        });

        $(scope).on("keydown", ".panel-heading", function (e) {
            // toggle expand/collapse on spacebar press
            if (e.keyCode == 32) {
                $(this).trigger("click");
                // disable page scrolling
                return false;
            }
        });

        function refresh(response) {
            // save currently focused element to restore its focus later
            var focusedInput = document.activeElement;

            _.invoke(facetValues, "resetCount");

            if (typeof (response.facets) !== "object") {
                return;
            }

            $.each(response.facets, function (id, count) {
                var parsed = SitecoreId.parse(id), 
                    facet = _.find(facetValues, function (p) {
                        return p.id.equals(parsed);
                    });

                if (facet) {
                    facet.count(count);
                }
            });

            // restore lost focus
            focusedInput.focus();
        }

        function deselectFacet(facet) {
            var deselect = _.find(facetValues, function (fv) {
                return fv.id.toString() === facet.id;
            });

            if (deselect) {
                deselect.selected(false);
            } else {
                deselect = _.find(self.facetRangePanels, function (fv) {
                    return fv.id.toString() === facet.id;
                });                

                if (!deselect) {
                    deselect = _.find(self.facetRatingsPanels, function (fv) {
                        return fv.id.toString() === facet.id;
                    });
                }   
                
                if (deselect) {
                    deselect.unselectAll();
                }
            }
        }        

        if (inputChangeEvents.length) {
            inputChangeEvents.forEach(function (ev) {
                eventManager.subscribe(SearchResponseEvent.eventName + ":" + ev, refresh);
                eventManager.subscribe(SearchRequestChangeEvent.deselectFacet + ":" + ev, deselectFacet);
                eventManager.subscribe(SearchRequestChangeEvent.clearFacets + ":" + ev, clearAll);
            });
        }

        function processPreselected(result, current) {
            var i = current.indexOf(":");
            var facetName = current.substr(0, i);
            var preselectedFacetValues = current.substr(i + 1).split("|");

            if (result.hasOwnProperty(facetName) === false) {
                result[facetName] = [];
            }

            result[facetName] = result[facetName].concat(preselectedFacetValues);
            return result;
        }

        ko.applyBindings(this, scope);
    }

    FacetContainer.init = function init(args) {
        return args.IsEditorEditing === true ? null : new FacetContainer(
            args.scope,
            args.UniqueId,
            args.InputChangeMessagesTransmitting || []
        );
    };

    return FacetContainer;
});
